import Service from '@/helpers/adminService'

export default {

    index(params) {
        return Service().get('admin/schedules', {params});
    },
    create(params) {
        return Service().post('admin/schedules', params);
    },
    update(id, params) {
        return Service().post('admin/schedules/'+id, params);
    },
    delete(id) {
        return Service().delete('admin/schedules/'+id);
    },
}
